export enum HeaderThemeEnum {
  transparent="transparent",
  black="black",
}
